import { render, staticRenderFns } from "./MyAccountsDpostTab.vue?vue&type=template&id=ee987d88"
import script from "./MyAccountsDpostTab.vue?vue&type=script&lang=js"
export * from "./MyAccountsDpostTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee987d88')) {
      api.createRecord('ee987d88', component.options)
    } else {
      api.reload('ee987d88', component.options)
    }
    module.hot.accept("./MyAccountsDpostTab.vue?vue&type=template&id=ee987d88", function () {
      api.rerender('ee987d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/accounts/MyAccountsDpostTab.vue"
export default component.exports